<script setup lang="ts">
import type { ActivityFeedItem } from '@/types/learner';
import { activityTypeMap, type ActivityType } from '@/types/activity';
import { formatRelativeTime } from '@/utils/formatters';

defineProps<{
  items: ActivityFeedItem[];
}>();

function getActivityInfo(type: ActivityFeedItem['type']) {
  return activityTypeMap[type as ActivityType] || {
    icon: 'info',
    label: 'Activity',
    colorClass: '',
  };
}

function getActivityVerb(type: ActivityFeedItem['type']): string {
  const verbs: Record<string, string> = {
    course_started: 'Started',
    course_completed: 'Completed',
    certificate_earned: 'Earned a certificate for',
    pathway_started: 'Started pathway',
    pathway_completed: 'Completed pathway',
  };
  return verbs[type] || 'Activity';
}
</script>

<template>
  <div v-if="items.length > 0" class="dashboard-section dashboard-section-full">
    <div class="section-header">
      <h2>Recent Activity</h2>
      <RouterLink to="/activity" class="section-link">View all</RouterLink>
    </div>
    <div class="activity-feed">
      <div v-for="item in items" :key="item.id" class="activity-item">
        <div class="activity-avatar">
          <bb-icon :name="getActivityInfo(item.type).icon" decorative></bb-icon>
        </div>
        <div class="activity-content">
          <div class="activity-text">
            {{ getActivityVerb(item.type) }}
            <RouterLink
              v-if="item.learningObjectId && item.learningObjectTitle"
              :to="`/course/${item.learningObjectId}`"
              class="activity-course-link"
            >
              {{ item.learningObjectTitle }}
            </RouterLink>
            <RouterLink
              v-else-if="item.pathwayId && item.pathwayTitle"
              :to="`/pathway/${item.pathwayId}`"
              class="activity-course-link"
            >
              {{ item.pathwayTitle }}
            </RouterLink>
            <span v-else>{{ item.description }}</span>
          </div>
          <div class="activity-time">{{ formatRelativeTime(item.timestamp) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
